import { Record } from 'immutable';
export function makeUserId(userId) {
  return userId;
}
// Should only be used for base initialization
export const _makeUser = Record({
  // Casting to any here since it's a bit too much overhead to define a massive default for something we never interact with
  _original: {},
  atlassianAccountId: makeUserId(''),
  avatarUrl: undefined,
  mention: undefined,
  name: ''
});
export const makeUser = _makeUser;
export const makeUserFromSPIUser = spiUser => makeUser({
  _original: spiUser,
  atlassianAccountId: makeUserId(spiUser.atlassianAccountId),
  avatarUrl: spiUser.avatarUrl,
  mention: spiUser.mention,
  name: spiUser.name
});